<style lang="scss">



@media screen and (min-width: 55rem) {
  .milestore {
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    .milestore-subtitle {
      font-size: 1.187rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 400;
      color: #e5004f;
      margin-bottom: 2rem;
    }
    .milestore-title {
      font-size: 1.9375rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 400;
      color: #000000;
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: start;
      width: 80%;
      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 40%;
        // background-color: brown;
        .left-block {
          width: 100%;
          height: 25rem;
          margin-top: 10rem;
          .left-block-container {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-end;
            .left-block-top {
              display: flex;
              flex-direction: row;
              align-items: center;
              .year {
                font-size: 3rem;
                font-family:  'PingFang SC','Microsoft YaHei';
                font-weight: bold;
                color: #000000;
                opacity: 0.96;
                background: linear-gradient(0deg, #e5004f 0%, #453a94 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              .year-line {
                width: 122px;
                height: 5px;
                background: #e5004f;
                border-radius: 3px;
                margin-left: 1rem;
                margin-right: -2px;
              }
              .year-point {
                width: 20px;
                height: 20px;
                background: #e5004f;
                border-radius: 50%;
                margin-right: -1rem;
              }
            }
            .left-block-event-list {
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              align-items: flex-end;
              margin-right: 9rem;
              .left-block-event-item {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                font-size: 1.3rem;
                font-family:  'PingFang SC','Microsoft YaHei';
                font-weight: 800;
                color: #4a4a4a;
                line-height: 3.125rem;
                white-space: nowrap;
                .left-point {
                  margin-top: 1rem;
                  margin-right: 1rem;
                  margin-left: 1rem;
                  width: 1rem;
                  height: 1rem;
                  background-color: #e5004f;
                  border-radius: 50%;
                }
              }
            }
          }
          &:nth-child(2) {
            margin-top: -3rem;
          }
          &:nth-child(3) {
            margin-top: 1rem;
          }
          &:nth-child(4) {
            margin-top: 4rem;
          }
          &:nth-child(5) {
            margin-top: -3rem;
          }
          &:nth-child(6) {
            margin-top: -3rem;
          }
        }
        .left-block:first-child {
          margin-top: 0rem;
        }
        .left-block:last-child {
          margin-top: 0rem;
          height: 2rem;
        }
      }
      .line {
        width: 5px;
        height: 1330px;
        background: #e5004f;
      }
      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        width: 40%;
        // background-color: brown;
        .right-block {
          height: 25rem;

          width: 100%;
          margin-top: 10rem;
          .right-block-container {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            .right-block-top {
              display: flex;
              flex-direction: row;
              align-items: center;
              .year {
                font-size: 3rem;
                font-family:  'PingFang SC','Microsoft YaHei';
                font-weight: bold;
                color: #000000;
                opacity: 0.96;
                background: linear-gradient(0deg, #e5004f 0%, #453a94 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              .year-line {
                width: 122px;
                height: 5px;
                background: #e5004f;
                border-radius: 3px;
                margin-left: -1rem;
              }
              .year-point {
                width: 22px;
                height: 22px;
                background: #e5004f;
                border-radius: 50%;
                margin-left: -1rem;
              }
            }
            .right-block-event-list {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              margin-left: 9rem;
              .right-block-event-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 1.3rem;
                font-family:  'PingFang SC','Microsoft YaHei';
                font-weight: 800;
                color: #4a4a4a;
                line-height: 3.125rem;
                white-space: nowrap;
                .point {
                  margin-left: 1rem;
                  margin-right: 1rem;
                  width: 1rem;
                  height: 1rem;
                  background: #e5004f;
                  border-radius: 50%;
                }
              }
            }
          }
          .left-block:first-child {
            margin-top: 0rem;
          }
          &:nth-child(2) {
            margin-top: -1rem;
          }
          &:nth-child(3) {
            margin-top: -1rem;
          }
          &:nth-child(4) {
            margin-top: 5rem;
          }
          &:nth-child(5) {
            margin-top: -3rem;
          }
        }
        .right-block:first-child {
          margin-top: 9rem;
        }
      }
    }
  }

  .left-block-event-item2 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .left-block-event-item2-left {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      font-size: 1.5625rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 800;
      color: #4a4a4a;
      line-height: 3.125rem;
      white-space: nowrap;
    }

    .left-block-event-item2-right {
      margin-right: 1rem;
      margin-left: 1rem;
      width: 1rem;
      height: 1rem;
      background-color: #e5004f;
      border-radius: 50%;
    }
  }
}
@media screen and (max-width: 55rem) {
  .milestore {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    .milestore-subtitle {
      font-size: 0.8rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 400;
      color: #e5004f;
      margin-bottom: 1rem;
    }
    .milestore-title {
      font-size: 1.6rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 400;
      color: #000000;
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: start;
      width: 80%;
      // max-width: 1080px;
      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 40%;
        // background-color: brown;
        .left-block {
          width: 100%;
          height: 18rem;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-end;
          width: 100%;
          margin-top: 2.5rem;
          .left-block-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            width: 100%;

            .year {
              font-size: 1.4rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              font-weight: bold;
              color: #000000;
              opacity: 0.96;
              background: linear-gradient(0deg, #e5004f 0%, #453a94 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              white-space: nowrap;
            }
            .year-line {
              width: 50px;
              height: 2px;
              background: #e5004f;
              border-radius: 3px;
              margin-left: 1rem;
              margin-right: -2px;
            }
            .year-point {
              width: 10px;
              height: 10px;
              background: #e5004f;
              border-radius: 50%;
              margin-right: -0.5rem;
            }
          }
          .left-block-event-list {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            margin-right: 1rem;
            .left-block-event-item {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-end;
              font-size: 0.8rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              font-weight: 800;
              color: #4a4a4a;
              line-height: 1.5rem;
              .left-point {
                flex-shrink: 0;
                margin-top: 0.5rem;
                margin-right: 0.5rem;
                margin-left: 0.5rem;
                width: 0.5rem;
                height: 0.5rem;
                background-color: #e5004f;
                border-radius: 50%;
              }
            }
          }
          &:nth-child(2) {
            margin-top: -7rem;
          }
          &:nth-child(3) {
            margin-top: -3rem;
          }
          &:nth-child(4) {
            margin-top: -1rem;
          }
          &:nth-child(5) {
            margin-top: -8rem;
          }

          &:nth-child(6) {
            margin-top: -8rem;
          }
          &:nth-child(7) {
            margin-top: 20rem;
          }
          &:nth-child(8) {
            margin-top: 20rem;
          }
        }
        .left-block:first-child {
          margin-top: 0rem;
        }
        .left-block:last-child {
          margin-top: -5rem;
          height: 2rem;
        }
      }
      .line {
        width: 3px;
        height: 680px;

        background: #e5004f;
      }
      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 40%;
        .right-block {
          height: 18rem;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
          margin-top: 2.5rem;

          .right-block-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            .year {
              font-size: 1.4rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              font-weight: bold;
              color: #000000;
              opacity: 0.96;
              background: linear-gradient(0deg, #e5004f 0%, #453a94 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              white-space: nowrap;
            }
            .year-line {
              width: 50px;
              height: 2px;
              background: #e5004f;
              border-radius: 3px;
              margin-left: -0.5rem;
            }
            .year-point {
              width: 10px;
              height: 10px;
              background: #e5004f;
              border-radius: 50%;
              margin-left: -0.5rem;
            }
          }
          .right-block-event-list {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            margin-left: 0.5rem;
            .right-block-event-item {
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              font-size: 0.8rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              font-weight: 800;
              color: #4a4a4a;
              line-height: 1.5rem;

              .point {
                flex-shrink: 0;
                margin-left: 0.5rem;
                margin-right: 0.5rem;
                width: 0.5rem;
                height: 0.5rem;
                background: #e5004f;
                border-radius: 50%;
              }
            }
          }
          .left-block:first-child {
            margin-top: 0rem;
          }
          &:nth-child(2) {
            margin-top: -4rem;
          }
          &:nth-child(3) {
            margin-top: -4rem;
          }
          &:nth-child(4) {
            margin-top: -4rem;
          }
          &:nth-child(5) {
            margin-top: -8rem;
          }
          &:nth-child(6) {
            margin-top: 12rem;
          }
        }
        .right-block:first-child {
          margin-top: 5rem;
        }
      }
    }
  }
  .left-block-event-item2 {
    width: 100%;
    float: left;

    .left-block-event-item2-left {
      width: 100%;
      float: left;
      font-size: 0.8rem;
      font-family:  'PingFang SC','Microsoft YaHei';
      font-weight: 800;
      color: #4a4a4a;
      line-height: 1.5rem;
    }

    .left-block-event-item2-right {
      float: right;
      flex-shrink: 0;
      margin-right: 0.5rem;
      margin-left: 0.5rem;
      margin-top: -1rem;
      width: 0.5rem;
      height: 0.5rem;
      background-color: #e5004f;
      border-radius: 50%;
    }
  }
}
</style>

<template>
  <div class="milestore">
    <div class="milestore-subtitle">MILESTONE</div>
    <div class="milestore-title">银泰百货大事件</div>
    <div class="content">
      <div class="left">
        <div ref="left_1" class="left-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_left_1" class="left-block-container">
              <div class="left-block-top">
                <div class="year">1998年</div>
                <div class="year-line"></div>
                <div class="year-point"></div>
              </div>
              <div key="2" class="left-block-event-list">
                <div class="left-block-event-item">
                  首家门店杭州武林银泰开业
                  <div class="left-point"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div ref="left_2" class="left-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_left_2" class="left-block-container">
              <div class="left-block-top">
                <div class="year">2008-2012年</div>
                <div class="year-line"></div>
                <div class="year-point"></div>
              </div>
              <div class="left-block-event-list">
                <div class="left-block-event-item">
                  先后布局湖北、陕西、广西、北京、安徽等，商业版图不断扩大
                  <div class="left-point"></div>
                </div>
                <div class="left-block-event-item">
                  创立银泰网
                  <div class="left-point"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div ref="left_3" class="left-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_left_3" class="left-block-container">
              <div class="left-block-top">
                <div class="year">2019年</div>
                <div class="year-line"></div>
                <div class="year-point"></div>
              </div>
              <div class="left-block-event-list">
                <div class="left-block-event-item">
                  告别最后一台服务器
                  <div class="left-point"></div>
                </div>
                <div class="left-block-event-item">
                  成为全国首家100%云化、完全架构在云上的百货公司
                  <div class="left-point"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div ref="left_4" class="left-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_left_4" class="left-block-container">
              <div class="left-block-top">
                <div class="year">2024年</div>
                <div class="year-line"></div>
                <div class="year-point"></div>
              </div>
              <div class="left-block-event-list">
                <div class="left-block-event-item">
                  2024年12月，携手雅戈尔，面向未来，共同发展银泰
                  <div class="left-point"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div ref="left_5" class="left-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_left_4" class="left-block-container">
              <div v-show="this.active_left_4" class="left-block-top">
                <div class="year-point"></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="line"></div>
      <div class="right">
        <div ref="right_1" class="right-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_right_1" class="right-block-container">
              <div class="right-block-top">
                <div class="year-point"></div>
                <div class="year-line"></div>
                <div class="year">2000-2006年</div>
              </div>
              <div class="right-block-event-list">
                <div class="right-block-event-item">
                  <span class="point"></span
                  >收购宁波华联，首次跨入资本市场
                </div>
                 <div class="right-block-event-item">
                  <span class="point"></span>
                  宁波首家门店“宁波东门银泰百货”开业
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div ref="right_2" class="right-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_right_2" class="right-block-container">
              <div class="right-block-top">
                <div class="year-point"></div>
                <div class="year-line"></div>
                <div class="year">2018年</div>
              </div>
              <div class="right-block-event-list">
                <div class="right-block-event-item">
                  <span class="point"></span>
                  喵街APP上线
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  推出行业首个付费会员体系“INTIME365”
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  收购开元商业，商业版图再次扩大
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div ref="right_3" class="right-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_right_3" class="right-block-container">
              <div class="right-block-top">
                <div class="year-point"></div>
                <div class="year-line"></div>
                <div class="year">2019-2023年</div>
              </div>
              <div class="right-block-event-list">
                <div class="right-block-event-item">
                  <span class="point"></span>
                  数字化会员突破4000万
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  打造出47个美妆品牌“全国第一柜”
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  多年蝉联全国最大化妆品实体零售商
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  连续5年获评“德勤BMC卓越管理公司”大奖
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  40家银泰百货门店获评商务部认定的“绿色商场”
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div ref="right_4" class="right-block">
          <transition name="fade-in-up2">
            <div v-show="this.active_right_4" class="right-block-container">
              <div class="right-block-top">
                <div class="year-point"></div>
                <div class="year-line"></div>
                <div class="year">2025年</div>
              </div>
              <div class="right-block-event-list">
                <div class="right-block-event-item">
                  <span class="point"></span>
                  AI元年，Chat@韬略GPT3.0上线，数据计算速度提升10倍
                </div>
                <div class="right-block-event-item">
                  <span class="point"></span>
                  AI参与并提升的销售额已占银泰百货总销售额17%
                </div>
              </div>
            </div>
          </transition>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "milestore",
  components: {},
  data() {
    return {
      active_left_1: false,
      active_left_2: false,
      active_left_3: false,
      active_left_4: false,
      active_right_1: false,
      active_right_2: false,
      active_right_3: false,
      active_right_4: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.getDistance); //绑定页面滚动事件

    this.distance_left_1 =
      this.$refs.left_1.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_left_1 < 0 && this.active_left_1 == false) {
      this.active_left_1 = true;
    }

    this.distance_left_2 =
      this.$refs.left_2.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_left_2 < 0 && this.active_left_2 == false) {
      this.active_left_2 = true;
    }

    this.distance_left_3 =
      this.$refs.left_3.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_left_3 < 0 && this.active_left_3 == false) {
      this.active_left_3 = true;
    }

    this.distance_left_4 =
      this.$refs.left_4.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_left_4 < 0 && this.active_left_4 == false) {
      this.active_left_4 = true;
    }

    this.distance_right_1 =
      this.$refs.right_1.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_right_1 < 0 && this.active_right_1 == false) {
      this.active_right_1 = true;
    }

    this.distance_right_2 =
      this.$refs.right_2.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_right_2 < 0 && this.active_right_2 == false) {
      this.active_right_2 = true;
    }

    this.distance_right_3 =
      this.$refs.right_3.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_right_3 < 0 && this.active_right_3 == false) {
      this.active_right_3 = true;
    }

    this.distance_right_4 =
      this.$refs.right_4.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_right_4 < 0 && this.active_right_4 == false) {
      this.active_right_4 = true;
    }
  },
  methods: {
    getDistance() {
      this.distance_left_1 =
        this.$refs.left_1.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_left_1 < 0 && this.active_left_1 == false) {
        this.active_left_1 = true;
      }
      if (this.distance_left_1 > 0 && this.active_left_1 == true) {
        this.active_left_1 = false;
      }

      this.distance_left_2 =
        this.$refs.left_2.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_left_2 < 0 && this.active_left_2 == false) {
        this.active_left_2 = true;
      }
      if (this.distance_left_2 > 0 && this.active_left_2 == true) {
        this.active_left_2 = false;
      }

      this.distance_left_3 =
        this.$refs.left_3.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_left_3 < 0 && this.active_left_3 == false) {
        this.active_left_3 = true;
      }
      if (this.distance_left_3 > 0 && this.active_left_3 == true) {
        this.active_left_3 = false;
      }

      this.distance_left_4 =
        this.$refs.left_4.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_left_4 < 0 && this.active_left_4 == false) {
        this.active_left_4 = true;
      }
      if (this.distance_left_4 > 0 && this.active_left_4 == true) {
        this.active_left_4 = false;
      }

      this.distance_right_1 =
        this.$refs.right_1.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_right_1 < 0 && this.active_right_1 == false) {
        this.active_right_1 = true;
      }
      if (this.distance_right_1 > 0 && this.active_right_1 == true) {
        this.active_right_1 = false;
      }

      this.distance_right_2 =
        this.$refs.right_2.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_right_2 < 0 && this.active_right_2 == false) {
        this.active_right_2 = true;
      }
      if (this.distance_right_2 > 0 && this.active_right_2 == true) {
        this.active_right_2 = false;
      }

      this.distance_right_3 =
        this.$refs.right_3.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_right_3 < 0 && this.active_right_3 == false) {
        this.active_right_3 = true;
      }
      if (this.distance_right_3 > 0 && this.active_right_3 == true) {
        this.active_right_3 = false;
      }

      this.distance_right_4 =
        this.$refs.right_4.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_right_4 < 0 && this.active_right_4 == false) {
        this.active_right_4 = true;
      }
      if (this.distance_right_4 > 0 && this.active_right_4 == true) {
        this.active_right_4 = false;
      }
    },
  },
};
</script>
